import React, { useEffect } from 'react';
import Select from 'react-select';
import '../styles/InformacionPersonal.css';

const InformacionPersonal = ({ formData, handleChange, setFormData }) => {
  
  // Efecto para inicializar el array de menores cuando se selecciona "Sí"
  useEffect(() => {
    if (formData.menoresEdad === 'si' && (!Array.isArray(formData.nombresMenores) || formData.nombresMenores.length === 0)) {
      setFormData({
        ...formData,
        nombresMenores: [{ nombre: '', edad: '', neurodivergente: false, diagnostico: '' }]
      });
    }
  }, [formData.menoresEdad]);
  
  // Opciones de edad para react-select
  const edadOptions = [
    { value: '1 mes', label: '1 mes' },
    { value: '2 meses', label: '2 meses' },
    { value: '3 meses', label: '3 meses' },
    { value: '4 meses', label: '4 meses' },
    { value: '5 meses', label: '5 meses' },
    { value: '6 meses', label: '6 meses' },
    { value: '7 meses', label: '7 meses' },
    { value: '8 meses', label: '8 meses' },
    { value: '9 meses', label: '9 meses' },
    { value: '10 meses', label: '10 meses' },
    { value: '11 meses', label: '11 meses' },
    { value: '1 año', label: '1 año' },
    { value: '2 años', label: '2 años' },
    { value: '3 años', label: '3 años' },
    { value: '4 años', label: '4 años' },
    { value: '5 años', label: '5 años' },
    { value: '6 años', label: '6 años' },
    { value: '7 años', label: '7 años' },
    { value: '8 años', label: '8 años' },
    { value: '9 años', label: '9 años' },
    { value: '10 años', label: '10 años' },
    { value: '11 años', label: '11 años' },
    { value: '12 años', label: '12 años' },
    { value: '13 años', label: '13 años' },
    { value: '14 años', label: '14 años' },
    { value: '15 años', label: '15 años' },
    { value: '16 años', label: '16 años' },
    { value: '17 años', label: '17 años' }
  ];
  
  // Función para actualizar una propiedad específica (nombre o edad)
  const handleMenorChange = (index, campo, valor) => {
    // Asegurar que nombresMenores sea un array
    const nombresMenoresArray = Array.isArray(formData.nombresMenores) ? formData.nombresMenores : [{ nombre: '', edad: '', neurodivergente: false, diagnostico: '' }];
    const nuevosMenores = [...nombresMenoresArray];
    nuevosMenores[index][campo] = valor; // Acceso dinámico: 'nombre', 'edad', 'neurodivergente' o 'diagnostico'
    
    // Si se selecciona "No" en neurodivergente, vaciar el diagnóstico
    if (campo === 'neurodivergente' && valor === false) {
      nuevosMenores[index].diagnostico = '';
    }
    
    setFormData({ ...formData, nombresMenores: nuevosMenores });
  };

  const agregarMenor = () => {
    // Asegurar que nombresMenores sea un array
    const nombresMenoresArray = Array.isArray(formData.nombresMenores) ? formData.nombresMenores : [{ nombre: '', edad: '', neurodivergente: false, diagnostico: '' }];
    setFormData({
      ...formData,
      nombresMenores: [...nombresMenoresArray, { nombre: '', edad: '', neurodivergente: false, diagnostico: '' }]
    });
  };

  const eliminarMenor = (index) => {
    // Asegurar que nombresMenores sea un array
    const nombresMenoresArray = Array.isArray(formData.nombresMenores) ? formData.nombresMenores : [{ nombre: '', edad: '', neurodivergente: false, diagnostico: '' }];
    const filtrados = nombresMenoresArray.filter((_, i) => i !== index);
    setFormData({ ...formData, nombresMenores: filtrados });
  };

  return (
    <div>
      <h2 style={{
        fontSize: '1.5rem',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '1rem',
        display: 'flex',
        alignItems: 'center'
      }}>
        <span style={{
          backgroundColor: '#ddd6fe',
          color: '#7c3aed',
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '0.75rem',
          fontWeight: 'bold',
          fontSize: '0.875rem'
        }}>1</span>
        Información Personal
      </h2>
      
      <div className="info-personal-container">
        {/* Grupo 1: Nombre y Apellido */}
        <div className="form-grid-2">
          <div className="form-field">
            <label className="heading-section">Nombre</label>
            <input
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
              className="input-base input-nombre"
              placeholder="Tu nombre"
            />
          </div>
          
          <div className="form-field">
            <label className="heading-section">Apellido</label>
            <input
              type="text"
              name="apellido"
              value={formData.apellido}
              onChange={handleChange}
              required
              className="input-base input-apellido"
              placeholder="Tu apellido"
            />
          </div>
        </div>

        {/* Grupo 2: Email y Teléfono */}
        <div className="form-grid-2">
          <div className="form-field">
            <label className="heading-section">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="input-base input-email"
              placeholder="correo@email.com"
            />
          </div>
          
          <div className="form-field">
            <label className="heading-section">Celular</label>
            <input
              type="tel"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
              required
              className="input-base input-telefono"
              placeholder="+57 321 567 8900"
            />
          </div>
        </div>

        {/* Grupo 3: Fecha de Nacimiento */}
        <div className="form-grid-2">
          <div className="form-field">
            <label className="heading-section">Fecha de Nacimiento</label>
            <input
              type="date"
              name="fechaNacimiento"
              value={formData.fechaNacimiento}
              onChange={handleChange}
              required
              className="input-base input-fecha-nacimiento"
            />
          </div>
          <div className="form-field"></div> {/* Espacio vacío para mantener el grid */}
        </div>

        {/* Grupo 4: Menores de edad REFACTORIZADO */}
        <div className="menores-section">
          <label style={{ display: 'block', fontSize: '1rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
            ¿Asistirás con menores de edad?
          </label>
          <div className="radio-group">
            <label className="radio-label">
              <input
                type="radio"
                name="menoresEdad"
                value="si"
                checked={formData.menoresEdad === 'si'}
                onChange={handleChange}
                className="radio-input"
              />
              Sí
            </label>
            <label className="radio-label">
              <input
                type="radio"
                name="menoresEdad"
                value="no"
                checked={formData.menoresEdad === 'no'}
                onChange={handleChange}
                className="radio-input"
              />
              No
            </label>
          </div>
          
          {formData.menoresEdad === 'si' && (
<div style={{ marginTop: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              {Array.isArray(formData.nombresMenores) && formData.nombresMenores.length > 0 && formData.nombresMenores.map((menor, index) => (
                <React.Fragment key={index}>
                  <div key={index} className="menores-grid-row">
                  {/* Input Nombre */}
                  <div className="menor-nombre-container">
                    <label>Nombre Completo</label>
                    <input
                      type="text"
                      value={menor.nombre}
                      onChange={(e) => handleMenorChange(index, 'nombre', e.target.value)}
                      className="input-nombre-menor"
                      placeholder="Nombre"
                    />
                  </div>

                  {/* Select Edad */}
                  <div className="menor-edad-container">
                    <label>Edad</label>
                    <Select
                      value={edadOptions.find(option => option.value === menor.edad)}
                      onChange={(selectedOption) => handleMenorChange(index, 'edad', selectedOption ? selectedOption.value : '')}
                      options={edadOptions}
                      placeholder="Seleccionar edad"
                      isClearable
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: '42px',
                          fontSize: '14px',
                          borderColor: '#d1d5db',
                          '&:hover': { borderColor: '#9ca3af' }
                        }),
                        option: (base, state) => ({
                          ...base,
                          backgroundColor: state.isSelected ? '#3A7D5C' : 'white',
                          color: state.isSelected ? 'white' : '#1f2937',
                          fontWeight: state.isSelected ? 500 : 400,
                          '&:hover': {
                            backgroundColor: state.isSelected ? '#2d6147' : '#e8f5e8',
                            color: state.isSelected ? 'white' : '#1f2937'
                          }
                        })
                      }}
                    />
                  </div>
                  
                  {/* Radio Buttons Neurodivergente */}
                  <div className="menor-neuro-container">
                    <label>¿El menor tiene alguna neurodivergencia o discapacidad fisica?</label>
                    <div className="radio-group-neuro">
                      <label className="radio-label-neuro">
                        <input
                          type="radio"
                          name={`neurodivergente-${index}`}
                          id={`neurodivergente-si-${index}`}
                          checked={menor.neurodivergente === true}
                          onChange={() => handleMenorChange(index, 'neurodivergente', true)}
                        />
                        Sí
                      </label>
                      <label className="radio-label-neuro">
                        <input
                          type="radio"
                          name={`neurodivergente-${index}`}
                          id={`neurodivergente-no-${index}`}
                          checked={menor.neurodivergente === false}
                          onChange={() => handleMenorChange(index, 'neurodivergente', false)}
                        />
                        No
                      </label>
                    </div>
                  </div>
                  
                  {/* Input Diagnóstico (solo se muestra si neurodivergente es true) */}
                  {menor.neurodivergente === true && (
                    <div className="menor-diagnostico-container">
                      <label>Describa su diagnóstico o condición</label>
                      <input
                        type="text"
                        value={menor.diagnostico || ''}
                        onChange={(e) => handleMenorChange(index, 'diagnostico', e.target.value)}
                        className="input-diagnostico-menor"
                        placeholder="Describa el diagnóstico o condición"
                      />
                    </div>
                  )}
                  
                  {/* Botón Eliminar */}
                  {Array.isArray(formData.nombresMenores) && formData.nombresMenores.length > 1 ? (
                    <button
                      type="button"
                      onClick={() => eliminarMenor(index)}
                      className="btn-eliminar-menor"
                    >
                      ✕
                    </button>
                  ) : <div />}
                </div>
                
                {/* Línea separadora entre menores (excepto después del último) */}
                {index < formData.nombresMenores.length - 1 && (
                  <div className="separador-menores"></div>
                )}
                </React.Fragment>
              ))}

              <button
                type="button"
                onClick={agregarMenor}
                className="btn-agregar-menor"
              >
                + Agregar otro menor
              </button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default InformacionPersonal;